import dayjs from "dayjs";
import constants from "../common/constants";
import { renewToken } from "../features/auth/authSlice";
import Methods from "./Methods";
import { ARRAY_GROUP_SESSIONS } from "./SessionConstant";

const setSession = (window, key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    return false;
  }
  return true;
};

const setLoginDetails = (resp) => {
  console.log("resp", resp);
  const sessionData = [
    {
      key: constants.SS_KEY_GROUP_ACCESS_TOKEN,
      value: resp?.token?.replace(/^"|"$/g, ""),
    },
    {
      key: constants.SS_KEY_GROUP_ACCESS_TOKEN_EXPIRESBY,
      value: resp?.expiresIn,
    },
    { key: constants.SS_KEY_GROUP_REFRESH_TOKEN, value: resp?.refreshToken },
    {
      key: constants.SS_KEY_GROUP_REFRESH_TOKEN_EXPIRESBY,
      value: resp?.refreshExpiresIn,
    },
    { key: constants.SS_KEY_GROUP_TXN_ID, value: resp?.txnId },
    // { key: constants.SS_KEY_GROUP_USER_EMAIL, value: resp?.userInfo?.emailId },
  ];
  sessionData.forEach(({ key, value }) => {
    setSession(window, key, Methods.encryptData(JSON.stringify(value)));
  });
};

const clearSessionKey = (window, key) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    return false;
  }
  return true;
};

const clearSession = (window) => {
  try {
    window.sessionStorage.clear();
  } catch (error) {
    return false;
  }
  return true;
};

const getSession = (window, key) => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {}
  return null;
};

const getUserDetails = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_LOGIN_DETAILS);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getUserDetailsCookies = (cookies) => {
  try {
    const encData = cookies[constants.SS_KEY_GROUP_LOGIN_DETAILS];
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getClientSession = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_CLIENT_DETAILS);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getClientListSession = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_CLIENT_LIST);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getLoginDetails = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_LOGIN_DETAILS);
    const data = Methods.decrypt(encData);

    return data;
  } catch (error) {}
  return null;
};
const getClientListCookies = (cookies) => {
  try {
    const encData = cookies[constants.SS_KEY_GROUP_CLIENT_LIST];
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getClientSessionCookies = (cookies) => {
  try {
    const encData = cookies[constants.SS_KEY_GROUP_CLIENT_DETAILS];
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getPolicySession = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_POLICY_DETAILS);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getEndorsementFile = (window) => {
  try {
    const encData = getSession(
      window,
      constants.SS_KEY_GROUP_SET_ENDORSEMENT_FILE
    );
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getTicketNumber = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_TICKET_NUMBER);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getAccessToken = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN);
    const data = encData;
    return data;
  } catch (error) {}
  return null;
};

const getRefreshToken = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_REFRESH_TOKEN);
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getAccessTokenExpiry = (window) => {
  try {
    const encData = getSession(
      window,
      constants.SS_KEY_GROUP_ACCESS_TOKEN_EXPIRESBY
    );
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const updateTokenIfExpired = async (window, dispatch) => {
  const expireAt = await getAccessTokenExpiry(window);
  const timeDiff = await dayjs(expireAt).diff(dayjs());
  if (timeDiff < 1) {
    await dispatch(renewToken(getRefreshToken(window)));
  }
};

const getRefreshTokenExpiry = (window) => {
  try {
    const encData = getSession(
      window,
      constants.SS_KEY_GROUP_REFRESH_TOKEN_EXPIRESBY
    );
    const data = encData;
    console.log(data);
    return data;
  } catch (error) {}
  return null;
};

const getServiceRaiseExcelData = (window) => {
  try {
    const encData = getSession(
      window,
      constants.SS_KEY_GROUP_SERVICE_RAISE_EXCEL_DATA
    );
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getPolicySessionCookies = (cookies) => {
  try {
    const encData = cookies[constants.SS_KEY_GROUP_POLICY_DETAILS];
    const data = Methods.decrypt(encData);
    return data;
  } catch (error) {}
  return null;
};

const getMobileNumber = (window) => {
  try {
    const encData = getSession(window, constants.SS_KEY_GROUP_DATA_MOBILE);
    const data = encData;
    return data;
  } catch (error) {}
  return null;
};

const getEmails = (window) => {
  try {
    const email1 = getSession(window, constants.SS_KEY_GROUP_EMAIL1);
    const email3 = getSession(window, constants.SS_KEY_GROUP_EMAIL3);
    const email5 = getSession(window, constants.SS_KEY_GROUP_EMAIL5);
    return [email1, email3, email5];
  } catch (error) {}
  return null;
};

const setLocalStorage = (key, value) => {};

const getLocalStorage = (key) => {};

export {
  setSession,
  setLoginDetails,
  clearSessionKey,
  getSession,
  clearSession,
  getUserDetails,
  getUserDetailsCookies,
  getClientSessionCookies,
  getPolicySessionCookies,
  getServiceRaiseExcelData,
  getLoginDetails,
  getClientListCookies,
  getClientListSession,
  getClientSession,
  getPolicySession,
  getTicketNumber,
  setLocalStorage,
  getLocalStorage,
  getAccessToken,
  getAccessTokenExpiry,
  getRefreshToken,
  getRefreshTokenExpiry,
  getMobileNumber,
  getEndorsementFile,
  getEmails,
  updateTokenIfExpired,
};
